import { CURRENCY_SYMBOL } from "utils/constants";
import { costToFrench } from "utils/helpers/values";
import { get } from "lodash";

const Card = ({
  insurancePlan,
  cost,
  currency,
  translation,
  addLinks,
  index,
  upsells,
}) => {
  const totalCost = upsells.reduce((acc, { cost }) => (acc += cost), cost);
  const monthlyCost = costToFrench(totalCost);
  const annualCost = costToFrench(totalCost * 12);
  const currencySymbol = CURRENCY_SYMBOL[currency] || CURRENCY_SYMBOL.EUR;

  return (
    <div className="quote-template-acoris__formula">
      <div className="quote-template-acoris__formula--name">
        {insurancePlan?.name || `Formule ${index + 1}`}
        {upsells.length > 0 && (
          <span className="quote-template-acoris__formula--upsells">
            {upsells
              .map((upsell) => get(upsell, "insurancePlan.name"))
              .join(" + ")}
          </span>
        )}
      </div>
      <div className="quote-template-acoris__formula--price">
        <div className="quote-template-acoris__formula--price-monthly">
          {monthlyCost}&nbsp;{currencySymbol}
          <span> {translation.PER_MONTH}</span>
        </div>
        <div className="quote-template-acoris__formula--price-annual">
          {annualCost}&nbsp;{currencySymbol} {translation.PER_YEAR}
        </div>
      </div>
      {addLinks ? (
        <div className="quote-template-acoris__formula--button">
          {translation.LINK}
        </div>
      ) : null}
    </div>
  );
};

export default Card;
